import { render, staticRenderFns } from "./RequisitionListPage.vue?vue&type=template&id=c32831de&"
import script from "./RequisitionListPage.vue?vue&type=script&lang=ts&"
export * from "./RequisitionListPage.vue?vue&type=script&lang=ts&"
import style0 from "./RequisitionListPage.vue?vue&type=style&index=0&id=c32831de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports